export const envs = {
  isDevelopment:
    process.env.NODE_ENV === 'development' || process.env.NODE_ENV === 'test',
  isProduction: process.env.NODE_ENV === 'production',
  devPermissionOverrideKey:
    process.env.NEXT_PUBLIC_DEV_PERMISSION_OVERRIDE_KEY ?? 'userProfile',
  authApiPermissionKey:
    process.env.NEXT_PUBLIC_AUTH_API_PERMISSION_KEY ?? 'authApiPermission',
  googleClientId: process.env.NEXT_PUBLIC_GOOGLE_CLIENT_ID ?? '',
  googleAuthHttpUrl: process.env.NEXT_PUBLIC_GOOGLE_AUTH_URL ?? '',
  graphqlHttpUrl: process.env.NEXT_PUBLIC_GRAPHQL_HTTP_URL ?? '',
  restApiUrl: process.env.NEXT_PUBLIC_REST_API_URL ?? '',
  graphqlWsUrl: process.env.NEXT_PUBLIC_GRAPHQL_WS_URL ?? '',
  ddApplicationId: process.env.NEXT_PUBLIC_DD_APPLICATION_ID ?? '',
  ddClientToken: process.env.NEXT_PUBLIC_DD_CLIENT_TOKEN ?? '',
  ddService: process.env.NEXT_PUBLIC_DD_SERVICE ?? '',
  ddSite: process.env.NEXT_PUBLIC_DD_SITE ?? '',
  ddEnv: process.env.NEXT_PUBLIC_DD_ENV ?? '',
  ddVersion: process.env.NEXT_PUBLIC_DD_VERSION ?? '',
  cerberusApiUrl: process.env.NEXT_PUBLIC_CERBERUS_URL ?? '',
  clientUrl: process.env.NEXT_PUBLIC_CLIENT_URL ?? '',
  unleashUri: process.env.NEXT_PUBLIC_UNLEASH_URI ?? '',
  unleashClientKey: process.env.NEXT_PUBLIC_UNLEASH_CLIENT_KEY ?? '',
  unleashRefreshInterval:
    process.env.NEXT_PUBLIC_UNLEASH_REFRESH_INTERVAL ?? '',
  unleashAppName: process.env.NEXT_PUBLIC_UNLEASH_APP_NAME ?? '',
  raioWebUrl: process.env.NEXT_PUBLIC_RAIO_URL ?? '',

  firebaseApiKey: process.env.NEXT_PUBLIC_FIREBASE_API_KEY ?? '',
  firebaseAuthDomain: process.env.NEXT_PUBLIC_FIREBASE_AUTH_DOMAIN ?? '',
  firebaseProjectId: process.env.NEXT_PUBLIC_FIREBASE_PROJECT_ID ?? '',
  firebaseStorageBucket: process.env.NEXT_PUBLIC_FIREBASE_STORAGE_BUCKET ?? '',
  firebaseMessagingSenderId:
    process.env.NEXT_PUBLIC_FIREBASE_MESSAGING_SENDER_ID ?? '',
  firebaseAppId: process.env.NEXT_PUBLIC_FIREBASE_APP_ID ?? '',
  firebaseMeasurementId: process.env.NEXT_PUBLIC_FIREBASE_MEASUREMENT_ID ?? '',
}
